<template>
  <div class="title">
    <img src="../../static/image/common/left.png" alt="" />
    <div class="title-dec">
      <p>{{ title }}</p>
      <p>{{ titleEn }}</p>
    </div>
    <img src="../../static/image/common/right.png" alt="" />
  </div>
</template>
<script>
export default {
  name: 'FullScreen',
  props: {
    title: {
      type: String
    },
    titleEn: {
      type: String
    }
  },
  data () {
    return {}
  },
  methods: {},
  created () {},
  destroyed () {}
}
</script>
<style scoped>
.title {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title-dec {
  margin: 0 28px;
  text-align: center;
  color: #000;
  font-weight: 300;
}
.title-dec p:nth-child(1) {
  font-size: 36px;
  margin-bottom: 2px;
  color: #333;
}
.title-dec p:nth-child(2) {
  font-size: 24px;
  color: #999;
}
.title img {
  width: 238px;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// src/common/Title.vue